import { translateBackend } from '@assets/i18n/config';
import type { Goal } from '@interfaces/goalSubAccountTypes';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { SelectionTile } from '@ovComponents/3-pattern/selectionTile/selectionTile';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { kebabCase } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type ICreateSubAccountForAccountVisualProps = {
  options: any;
  goals: Goal[];
  loading: boolean;
  selectedGoal?: string;
  setSelectedGoal: (goal: string) => void;
  continueFunc: () => void;
};

export const CreateSubAccountForAccountVisual: React.FC<
  ICreateSubAccountForAccountVisualProps
> = ({
  options,
  goals,
  loading,
  selectedGoal,
  setSelectedGoal,
  continueFunc,
}) => {
  const { t } = useTranslation('client');

  const submit = async () => {
    if (selectedGoal) {
      await continueFunc();
    }
  };

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      testId='create-subaccount-for-account-form'
      submitButtonProps={{
        label: t('continue'),
        disabled: loading || !selectedGoal,
        dataTestId: `create-subaccount-for-account-${kebabCase(translateBackend(options.title))}-continue-button`,
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 3 }}>
        <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
          {translateBackend(options?.subtitle)}
        </ReactMarkdown>
      </Typography>
      <SelectionTile
        testId='selected-goal'
        onChange={(e) => setSelectedGoal(e.target.value)}
        value={selectedGoal ?? ''}
        options={goals.map((goal) => ({
          value: goal.id,
          label: goal.name ?? '',
        }))}
        error={!loading && goals.length === 0}
        errorText={t('goalsSummary.noGoals')}
      />
    </WorkflowCompletionForm>
  );
};
